import BasketIcon from "./BasketIcon.js";

export default class BasketIconHandler {
    value = 0
    icons = []

    load(initialValue) {
        document.querySelectorAll('.basket-icon').forEach(wrapper => {
            const svg = wrapper.querySelector('svg')
            this.addIcon(svg)
        })

        this.setValue(initialValue, true)
    }

    addIcon(svg) {
        this.icons.push(new BasketIcon(svg))
    }

    setValue(value, initial = false) {
        this.icons.forEach(icon => icon.setValue(value, initial))
        this.value = value
    }

    increase(amount) {
        this.setValue(this.value + amount)
    }

    decrease(amount) {
        this.setValue(this.value - amount)
    }
}
